import { getUrlBoolean } from '@/helpers/UrlParam';
import { Trans } from 'react-i18next';
import AssetService from '@/services/AssetService';
import dayjs from 'dayjs';
import { useState, useMemo, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/stores/app';
import { Popup } from '@/components/_misc/Popup';

function calculateAge(dateOfBirth) {
  if (!dateOfBirth) return 0;

  const today = dayjs();
  const birthDate = dayjs(dateOfBirth);

  // Calculate age using dayjs diff method
  return today.diff(birthDate, 'year');
}

export const VerifyAge = () => {
  // const dob = useAppStore((state) => state.dob);
  // const setDob = useAppStore((state) => state.setDob);

  const [day, setDay] = useState(1);
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState(2007);

  const setPopup = useAppStore((state) => state.setPopup);
  const verified = useAppStore((state) => state.verified);
  const setVerified = useAppStore((state) => state.setVerified);
  const [agree, setAgree] = useState(false);

  const [error, setError] = useState('');

  const { t } = useTranslation();
  const ageLimit = parseInt(t('general.ageLimit'));

  const dob = `${year}-${month}-${day}`;
  const age = useMemo(() => calculateAge(dob) || 0, [dob]);
  // console.log(year, month, day, dob, age);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    AssetService.getAsset('s_button').play();
    setError(null);

    if (!dob) {
      setError(t('verify.error.dobEmpty'));
      return;
    }

    if (age < ageLimit) {
      setError(
        // `You must be at least ${ageLimit} years old to enter this site.`
        t('verify.error.dobLimit', { ageLimit })
      );
      return;
    }

    if (!agree) {
      setError(t('verify.error.agree'));
      return;
    }

    setVerified(true);
    setPopup('prizes');
  };

  // const onButtonClick = useCallback((evt) => {
  //   // evt.preventDefault();
  //   AssetService.getAsset('s_button').play();
  // }, []);

  useLayoutEffect(() => {
    const skipVerifyAge = getUrlBoolean('skipVerifyAge');
    if (skipVerifyAge) {
      setVerified(true);
      setPopup(null);
    }
  }, []);

  const days = new Array(31).fill(0).map((_, i) => i + 1);
  const months = new Array(12).fill(0).map((_, i) => i + 1);
  const years = new Array(100).fill(0).map((_, i) => 2025 - i);

  const onClick = (evt, id) => {
    evt.preventDefault();
    // setPopup(id);
  };

  return (
    <>
      <Popup
        popupId="verify"
        closable={false}
        className="frame-brown"
      >
        <div className={cn('verify-age', 'w-full')}>
          <form onSubmit={handleSubmit}>
            <h2 className="typo-h2 mb-3 whitespace-pre-line">
              {t('verify.heading')}
            </h2>

            <div className={cn('')}>
              <div
                className={cn(
                  'flex-center-row justify-between tracking-[0.05em]'
                )}
              >
                <h2>{t('verify.dob')}</h2>
                <div>
                  {t('verify.age')}: {age}
                </div>
              </div>
              <div
                className={cn(
                  'flex-center-row my-1 h-[4.6rem] items-stretch gap-1',
                  'font-silkscreen text-[2rem] font-normal tracking-[-0.11em]'
                )}
              >
                <select
                  className={cn('frame-white flex-1')}
                  value={day}
                  onChange={(e) => setDay(e.target.value)}
                >
                  {days.map((day) => (
                    <option
                      value={day}
                      key={day}
                    >
                      {day}
                    </option>
                  ))}
                </select>
                <select
                  className={cn('frame-white flex-1')}
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  {months.map((month) => (
                    <option
                      value={month}
                      key={month}
                    >
                      {month}
                    </option>
                  ))}
                </select>

                <select
                  className={cn('frame-white flex-2')}
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                >
                  {years.map((year) => (
                    <option
                      value={year}
                      key={year}
                    >
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={cn('flex-center-row my-3 gap-1')}>
              <input
                type="checkbox"
                name="terms"
                id="terms"
                value={agree}
                onChange={(e) => setAgree(e.target.checked)}
                className="sr-only"
              />
              <label htmlFor="terms">
                <div className={cn('frame-white', agree && 'bg-yellow')} />
              </label>

              <label
                htmlFor="terms"
                className="font-gellix text-[1.1rem] leading-[1.1] font-bold tracking-[0.05em]"
              >
                <Trans
                  i18nKey="verify.agree"
                  components={{
                    termsLink: (
                      <a
                        // onClick={(evt) => onClick(evt, 'terms')}
                        className={cn('inline underline')}
                        href={t('verify.terms.link')}
                        target="_self"
                      >
                        {t('verify.terms.label')}
                      </a>
                    ),
                    privacyLink: (
                      <a
                        // onClick={(evt) => onClick(evt, 'privacy')}
                        className={cn('inline underline')}
                        href={t('verify.privacy.link')}
                        target="_self"
                      >
                        {t('verify.privacy.label')}
                      </a>
                    ),
                  }}
                />
              </label>
            </div>

            <button
              // onClick={handleSubmit}
              type="submit"
              className={cn(
                'btn-primary h-[4.6rem] w-full',
                'text-[2rem] leading-none tracking-[-0.019em]'
              )}
            >
              {t('verify.cta')}
              <img
                src="assets/images-next/arrow-right.webp"
                className="ml-1 h-[1.5rem] text-[1.5rem] leading-none"
              />
            </button>

            {error && (
              <div
                className={cn(
                  'text-red mt-2 w-full text-center whitespace-pre-line',
                  'font-gellix text-[1.1rem] leading-[1.1] font-bold tracking-[0.05em]'
                )}
              >
                {error}
              </div>
            )}
          </form>
        </div>
      </Popup>
    </>
  );
};
